import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  // --- ESTADOS DE AUTENTICAÇÃO ---
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const SECRET_PASSWORD = 'oN/8]43Z8*$hd*~=k~)6;l<@+3@[S.`1qS';

  // --- ESTADOS DA APLICAÇÃO ---
  const [database, selectDatabase] = useState('Malta');
  const [searchTerm, setSearchTerm] = useState('');
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [filteredAnswers, setFilteredAnswers] = useState([]);

  // Verifica se o usuário já fez login nesta sessão
  useEffect(() => {
    const loggedIn = localStorage.getItem('zerobot_auth');
    if (loggedIn === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (passwordInput === SECRET_PASSWORD) {
      setIsAuthenticated(true);
      // Salva a permissão definitivamente no navegador
      localStorage.setItem('zerobot_auth', 'true');
    } else {
      toast.error("Senha incorreta!");
    }
  };

  const onSelectDatabase = (database) => {
    selectDatabase(database);
    localStorage.setItem('database', database);
    fetch(`/data/zerobot-support-${database}.json`)
      .then((response) => response.json())
      .then((data) => {
        const questionList = data.map((item) => item.Question);
        const answerList = data.map((item) => item.Answer);

        setQuestions(questionList);
        setAnswers(answerList);
        setFilteredQuestions(questionList);
        setFilteredAnswers(answerList);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }

  // Fetch the JSON data ONLY if authenticated
  useEffect(() => {
    if (!isAuthenticated) return; // Não faz o fetch se não estiver logado

    const db = localStorage.getItem('database') || database;
    selectDatabase(db);
    fetch(`/data/zerobot-support-${db}.json`)
      .then((response) => response.json())
      .then((data) => {
        const questionList = data.map((item) => item.Question);
        const answerList = data.map((item) => item.Answer);

        setQuestions(questionList);
        setAnswers(answerList);
        setFilteredQuestions(questionList);
        setFilteredAnswers(answerList);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [database, isAuthenticated]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    const filtered2 = [];
    const filtered = questions.filter((question) => {
      const index = questions.indexOf(question);
      if (question.toLowerCase().includes(value.toLowerCase())) {
        filtered2.push(answers[index]);
        return true;
      }
      return false;
    });

    answers.forEach((answer, index) => {
      if (answer.toLowerCase().includes(value.toLowerCase())) {
        if (!filtered.includes(questions[index])) {
          filtered.push(questions[index]);
          filtered2.push(answer);
        }
      }
    });
    setFilteredQuestions(filtered);
    setFilteredAnswers(filtered2);
  };

  const selectQuestion = (index) => {
    toast.success("Questão copiada: " + filteredQuestions[index]);
    const textArea = document.createElement("textarea");
    textArea.value = filteredAnswers[index];
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback copy failed: ", err);
    }
    document.body.removeChild(textArea);
  }

  // --- TELA DE LOGIN ---
  if (!isAuthenticated) {
    return (
      <div style={styles.container}>
        <div style={styles.loginBox}>
          <h2>Acesso Restrito</h2>
          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <input
              type="password"
              placeholder="Digite a senha"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              style={styles.input}
            />
            <button type="submit" style={styles.loginButton}>Entrar</button>
          </form>
        </div>
        <ToastContainer theme="dark" />
      </div>
    );
  }

  // --- TELA PRINCIPAL (Seu código original) ---
  return (
    <div style={styles.container}>
      <button
        onClick={() => window.location.href = 'https://discord.zerobot.net/fetch-tickets-ui'}
        style={{ alignSelf: 'flex-start', marginBottom: '20px', padding: '10px 15px', backgroundColor: '#444', color: 'white', border: 'none', cursor: 'pointer', borderRadius: '5px' }}
      >
        ➡️ Ticket Manager
      </button>
      <h1>Buscar Respostas</h1>
      <p>Selecione o banco de dados:</p>
      <select style={styles.select} onChange={(e) => onSelectDatabase(e.target.value)} value={database}>
        <option value="Malta">Malta</option>
      </select>
      <br />
      <input
        type="text"
        placeholder="Buscar..."
        value={searchTerm}
        onChange={handleInputChange}
        style={styles.input}
      />
      <ul style={styles.list}>
        {filteredQuestions.map((question, index) => (
          <li key={index} style={styles.listItem} onClick={() => selectQuestion(index)}>
            {question}
          </li>
        ))}
      </ul>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}

// Basic styling atualizado
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    backgroundColor: '#000',
    color: '#fff',
  },
  loginBox: {
    marginTop: '150px',
    padding: '40px',
    backgroundColor: '#111',
    border: '1px solid #333',
    borderRadius: '8px',
    textAlign: 'center',
  },
  loginButton: {
    padding: '10px',
    backgroundColor: '#0066cc',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  select: {
    width: '120px',
    padding: '5px',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    width: '300px',
    marginBottom: '20px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    width: '300px',
    backgroundColor: "#222",
    borderRadius: '8px',
    overflow: 'hidden',
  },
  listItem: {
    padding: '15px',
    borderBottom: '1px solid #333',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
};

export default App;